import { render, staticRenderFns } from "./ActiveInactiveBadge.vue?vue&type=template&id=0ead1aa9&scoped=true&"
import script from "./ActiveInactiveBadge.vue?vue&type=script&lang=js&"
export * from "./ActiveInactiveBadge.vue?vue&type=script&lang=js&"
import style0 from "./ActiveInactiveBadge.vue?vue&type=style&index=0&id=0ead1aa9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ead1aa9",
  null
  
)

export default component.exports